import { styled } from 'styled-components';
import { Icon } from '../Icon';

const StyledIconContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  height: 0;
`;

export type DataCardHoverArrowProps = object;

export const DataCardHoverArrow = (props: DataCardHoverArrowProps) => (
  <StyledIconContainer {...props}>
    <Icon
      data-wui-data-card-hover-icon={true}
      type="arrow-right"
    />
  </StyledIconContainer>
);

DataCardHoverArrow.displayName = 'DataCardHoverArrow';
